export default "__VITE_ASSET__CIAVQ5RD__"